import React from 'react';

import { useIntl } from 'react-intl';

import IconButton from '@atlaskit/button/icon/button';
import { cssMap } from '@atlaskit/css';
import CrossIcon from '@atlaskit/icon/core/cross';
import { Flex } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import messages from './messages';

const inPromptHeaderStyles = cssMap({
	default: {
		display: 'inline-flex',
		// make room for the focus ring
		marginRight: token('space.050'),
	},
});

type Props = {
	onClick?: () => void;
};

const toolTipProps: React.ComponentProps<typeof IconButton>['tooltip'] = { position: 'top' };
export const testId = 'close-preview-icon-button';

export const ClosePreviewIconButton = ({ onClick }: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Flex xcss={inPromptHeaderStyles.default}>
			<IconButton
				appearance="subtle"
				icon={CrossIcon}
				label={formatMessage(messages.closePreviewLabel)}
				spacing="compact"
				onClick={onClick}
				testId={testId}
				tooltip={toolTipProps}
				isTooltipDisabled={false}
			/>
		</Flex>
	);
};
